import { useLocale } from '../../preferences/i18n/LocaleProvider';

export function ArchiveErrorDialog({ message, onClose }: { message: string; onClose: () => void }) {
	const { t } = useLocale();

	if (!message) return null;

	return (
		<div role="alertdialog" aria-label={t('archiveImportFailedTitle')} className="floating-panel">
			<div className="hud-stack" style={{ minWidth: 320, maxWidth: 380 }}>
				<h2 style={{ margin: 0, fontSize: '1rem' }}>{t('archiveImportFailedTitle')}</h2>
				<p style={{ margin: 0 }}>{message}</p>
				<p className="hud-hint">{t('archiveImportFailureLayoutNote')}</p>
				<button className="hud-subtle-button" onClick={onClose} type="button">{t('close')}</button>
			</div>
		</div>
	);
}
